import { render, staticRenderFns } from "./CriticalitiesList.vue?vue&type=template&id=5a931d4e&scoped=true&"
import script from "./CriticalitiesList.vue?vue&type=script&lang=js&"
export * from "./CriticalitiesList.vue?vue&type=script&lang=js&"
import style0 from "./CriticalitiesList.vue?vue&type=style&index=0&id=5a931d4e&lang=scss&scoped=true&"
import style1 from "./CriticalitiesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a931d4e",
  null
  
)

export default component.exports